import type {
  PatchDocumentsArchiveRequestType,
  PatchDocumentsArchiveResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const patchDocumentsArchive = async ({
  boardId,
  ids,
}: PatchDocumentsArchiveRequestType) => {
  const url = `api/v2/boards/${boardId}/documents/archive`;
  const response = await apiAuthClient.patch<PatchDocumentsArchiveResponseType>(
    url,
    {
      ids,
    },
  );

  return response.data;
};
